<ng-container *transloco="let t">
<ng-template #multiBorrowerAddressHistory>
  <div class="card shadow-sm mb-5">
    <div class="card-header">
        <h3 class="card-title">{{mainBorrower.firstName + " " + mainBorrower.lastName}}</h3>
    </div>
    <div class="card-body">
      <borrower-address-history
        #borrowerAddressHistory
        [inEditMode]="isStepBeingEdited"
        [mortgage]="mortgage"
        [borrower]="mainBorrower"
        [reoFieldsToConfig]="reoFieldsToConfig"
        [currentAddressLabel]="t('wizard.myInfo.myHomeAddress')" >
      </borrower-address-history>
    </div>
  </div>

  @if (!inCoApplyFlow) {
    @for (borrower of coBorrowers; track borrower.borrowerId) {
      @if (borrowerSetting(borrower)) {
        <div class="card shadow-sm mb-5" >
            <div class="card-header">
              <h3 class="card-title">{{borrower.firstName + " " + borrower.lastName}}</h3>
              <a (click)="onCopyFromPrimaryBorrowerClicked(borrower)" class="pull-right mt-6 fs-6">{{ t('wizard.addressHistory.copyFrom', { name: mainBorrower.firstName + ' ' + mainBorrower.lastName }) }}</a>
            </div>
            <div class="card-body">
              <borrower-address-history
                #borrowerAddressHistory
                [mortgage]="mortgage"
                [borrower]="borrower"
                [reoFieldsToConfig]="reoFieldsToConfig"
                [currentAddressLabel]="t('wizard.addressHistory.currentAddress')">
              </borrower-address-history>
            </div>
        </div>
      }
    }
  }

</ng-template>

<wizard-step-template [stepMainTemplate]="multiBorrowerAddressHistory" [step]="step" [stepComponent]="this"></wizard-step-template>
</ng-container>
